import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'user_details.user_table',
        path: `${APP_PREFIX_PATH}/user_details/user_table`,
        component: React.lazy(() => import('views/app-views/user_details/user_table')),
    },
    {
        key: 'user_details.delete_users',
        path: `${APP_PREFIX_PATH}/user_details/delete_users`,
        component: React.lazy(() => import('views/app-views/user_details/delete_users')),
    },
    {
        key: 'service_man_details.service_man_table',
        path: `${APP_PREFIX_PATH}/service_man_details/service_man_table`,
        component: React.lazy(() => import('views/app-views/service_man_details/service_man_table')),
    },
    {
        key: 'service_man_details.deleted_service_man',
        path: `${APP_PREFIX_PATH}/service_man_details/deleted_service_man`,
        component: React.lazy(() => import('views/app-views/service_man_details/deleted_service_man')),
    },
    {
        key: 'shop_details.verifed_shop',
        path: `${APP_PREFIX_PATH}/shop_details/verifed_shop`,
        component: React.lazy(() => import('views/app-views/shop_details/shop_data')),
    },
    {
        key: 'shop_details.unverify',
        path: `${APP_PREFIX_PATH}/shop_details/unverify`,
        component: React.lazy(() => import('views/app-views/shop_details/shop_table')),
    },
    {
        key: 'shop_details.add_shop',
        path: `${APP_PREFIX_PATH}/shop_details/add_shop`,
        component: React.lazy(() => import('views/app-views/shop_details/add_shop')),
    },
    {
        key: 'services',
        path: `${APP_PREFIX_PATH}/services`,
        component: React.lazy(() => import('views/app-views/services')),
    },
    {
        key: 'mobiles-phone_brand',
        path: `${APP_PREFIX_PATH}/mobiles/phone_brand`,
        component: React.lazy(() => import('views/app-views/mobiles/phone_brand')),
    },
    {
        key: 'mobiles-phone_model',
        path: `${APP_PREFIX_PATH}/mobiles/phone_model`,
        component: React.lazy(() => import('views/app-views/mobiles/phone_model')),
    }
]